module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point1_2-6e9446838342eddd2fd2f96eb526653a.jpg";